// components/ButtonGroup.jsx

import { useIsMobile } from "@components/mediaQuery/useIsMobile";
import { checkPermission } from "@utils/permissions";
import { useState } from "react";
import { useSelector } from "react-redux";

const ButtonGroup = ({
	onConfigurationClick,
	onMonitoringClick,
	onActivationClick,
	selectedContent,
	canDisplayActivationProv = false,
}) => {
	const [selected, setSelected] = useState(selectedContent);
	const { permissions } = useSelector((state) => state.auth.user);

	const vesselsSite = permissions.find((resource) => resource.resource_name === "vessels_site");
	const vesselStarlinks = vesselsSite?.providers?.find(
		(subResource) => subResource.sub_resource_name === "modules",
	);
	const authorizedPermissions = vesselStarlinks?.permissions?.filter(
		(permission) => permission.authorized === true,
	);

	const canViewActivationConfig = checkPermission(authorizedPermissions, "view activation config");

	const canViewMonitoring = checkPermission(authorizedPermissions, "view monitoring");

	const canViewActivationProv = checkPermission(authorizedPermissions, "view activation prov");

	const handleConfigurationClick = () => {
		setSelected("configuration");
		onConfigurationClick();
	};
	const handleMonitoringClick = () => {
		setSelected("monitoring");
		onMonitoringClick();
	};

	const handleActivationClick = () => {
		setSelected("activation");
		onActivationClick();
	};

	const baseButtonClasses = `py-3 md:py-3 text-[8px] 
border focus:z-10 focus:ring-2 border-[#4C5476] text-white 
hover:text-white hover:bg-blue-gray hover:opacity-80 
focus:ring-blue-gray focus:text-white whitespace-nowrap`;
	const isMobile = useIsMobile();

	return (
		<div className="mb-2 flex w-full flex-col gap-2 sm:w-[60%]">
			<div
				className="mt-2 inline-flex w-full justify-center rounded-md shadow-sm sm:w-auto"
				role="group"
			>
				{canViewActivationConfig && (
					<button
						type="button"
						className={`${baseButtonClasses} flex-1 ${isMobile ? "rounded-s-none" : "rounded-s-lg"} py-2 text-[8px] sm:text-[8px] md:text-[10px] lg:text-[12px] xl:text-[14px] ${selected === "configuration" ? "bg-blue-gray" : "rounded-s-lg bg-dark-blue"}
    `}
						onClick={handleConfigurationClick}
					>
						VESSEL ACTIVATION CONFIG
					</button>
				)}

				{canViewMonitoring && (
					<button
						type="button"
						className={`${baseButtonClasses} flex-1 ${isMobile ? "rounded-s-none" : ""}
      ${!canViewActivationConfig ? "rounded-l-lg" : ""}
      ${!canViewActivationProv || !canDisplayActivationProv ? "rounded-e-lg" : ""} py-2 text-[8px] sm:text-[8px] md:text-[10px] lg:text-[12px] xl:text-[14px] ${selected === "monitoring" ? "bg-blue-gray" : "bg-dark-blue"}
    `}
						onClick={handleMonitoringClick}
					>
						MONITORING
					</button>
				)}
				{canViewActivationProv && canDisplayActivationProv && (
					<button
						type="button"
						className={`${baseButtonClasses} flex-1 ${isMobile ? "rounded-e-none" : "rounded-e-lg"} py-2 text-[8px] sm:text-[8px] md:text-[10px] lg:text-[12px] xl:text-[14px] ${selected === "activation" ? "bg-blue-gray" : "bg-dark-blue"}
    `}
						onClick={handleActivationClick}
					>
						ACTIVATION/PROV
					</button>
				)}
			</div>
		</div>
	);
};

export default ButtonGroup;
